import React from "react";
import { TextAndVideoBlock } from "../../lib/storyblok/types/blocks/TextAndVideoBlock";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import { useLinks } from "../../lib/storyblok/useLinks";
import Button from "../../ui/Button";
import MediaAndImageUi from "../../ui/MediaAndImage";
import { DynamicBlocks } from "../DynamicBlock";
import { useContentStyle, useButtonStyle } from "../../hooks/useStyle";

const TextAndVideo: StoryblokBlockComponent<TextAndVideoBlock> = ({
  style,
  text,
  title,
  video,
  reversed,
  dark,
  buttonText,
  buttonLink,
  secondButtonText,
  secondButtonLink,
  typeformCopy,
  typeformID,
  typeformSize,
  typeformButtonStyle,
  outerSpacing,
  mediaBackground,
  imageKeepProportions,
  layout,
  className,
  isActive,
  overlayVisible,
  assetVideo,
  thumbnailImage,
}) => {
  const resolveLink = useLinks();
  const contentStyle = useContentStyle(style);
  const isInverted = style === "" || style === undefined ? false : contentStyle;
  const { buttonVariant } = useButtonStyle(style);
  return (
    <MediaAndImageUi
      isActive={isActive}
      className={className}
      overlayVisible={overlayVisible}
      style={style === "white" || style === "gray" ? "none" : style}
      outerSpacing={outerSpacing}
      mediaBackground={mediaBackground}
      imageKeepProportions={imageKeepProportions}
      layout={layout}
      reversed={reversed}
      dark={dark}
      title={title}
      preamble={text}
      video={<DynamicBlocks blocks={video} />}
      assetVideo={assetVideo}
      thumbnailImage={thumbnailImage}
      button={
        buttonText && (
          <Button href={resolveLink(buttonLink)} variant={buttonVariant}>
            {buttonText}
          </Button>
        )
      }
      secondButton={
        secondButtonText && (
          <Button href={resolveLink(secondButtonLink)} variant={buttonVariant}>
            {secondButtonText}
          </Button>
        )
      }
      typeformCopy={typeformCopy}
      typeformID={typeformID}
      typeformSize={typeformSize}
      typeformButtonStyle={typeformButtonStyle}
      inverted={isInverted}
    />
  );
};

export default TextAndVideo;
